import type {
  PartnerAuthUserDto,
  PartnerLoginSessionDto,
  PartnerProfile,
  PartnerSession,
} from "@/types/partner";

export function mapPartnerProfile(dto: PartnerAuthUserDto): PartnerProfile {
  return {
    id: dto.id,
    email: dto.email,
    first_name: dto.first_name,
    last_name: dto.last_name,
    full_name: dto.full_name,
    phone_number: dto.phone_number ?? null,
    partner: dto.partner,
  };
}

export function mapLoginToSession(dto: PartnerLoginSessionDto): PartnerSession {
  return {
    tokens: {
      access: dto.access,
      refresh: dto.refresh,
    },
    profile: mapPartnerProfile(dto.user),
  };
}
